// axiosConfig.js
import axios from 'axios';
import { getAccessToken } from '../auth/tokenStore';

// Crear una instancia de Axios sin baseURL
const axiosInstance = axios.create({
    withCredentials: true,     // si tu backend lo usa
    timeout: 20000             // evita colgados infinitos
});

axiosInstance.interceptors.request.use((config) => {
    config.params = { ...(config.params || {}), _t: Date.now() };
    const existingAuthorization = config.headers?.Authorization || config.headers?.authorization;
    const contextToken = getAccessToken();
    const shouldReplaceLegacyToken = !existingAuthorization || existingAuthorization === 'Bearer null' || existingAuthorization === 'Bearer ';
    config.headers = {
        ...(config.headers || {}),
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
        'Content-Type': 'application/json',
        ...(existingAuthorization ? { Authorization: existingAuthorization } : {}),
        ...(shouldReplaceLegacyToken && contextToken ? { Authorization: `Bearer ${contextToken}` } : {}),
    };
    return config;
}, (error) => {
    return Promise.reject(error);
});

// Exportar la instancia configurada
export default axiosInstance;
